import styled from 'styled-components';

const LeftNavbarContainer = styled.div`
  position: fixed;
  display: block;
  padding: 40px 24px;
  left: 0;
  top: 72px;
  bottom: 0;
  width: 200px;
  max-width: 200px;
  background-color: white;
  z-index: 2;
  border: 1px solid #d1d1d1;
  box-shadow: 0px 4px 8px -2px rgba(77, 77, 77, 0.2),
    0px 2px 4px -2px rgba(77, 77, 77, 0.06);
  box-sizing: border-box;
  transition: 0.3s;

  > button {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

export { LeftNavbarContainer };
